import 'css-chunksrc/client/scenes/project/projectStatus/styles.scss';export default {
  "projectStatus": "_projectStatus_1mu7b_1",
  "selectedStatus": "_selectedStatus_1mu7b_6",
  "folderIcon": "_folderIcon_1mu7b_19",
  "name": "_name_1mu7b_25",
  "toggleArrow": "_toggleArrow_1mu7b_31",
  "menu": "_menu_1mu7b_38",
  "shortened": "_shortened_1mu7b_51",
  "minimized": "_minimized_1mu7b_58"
};